export const StudyResourceType = {
    REFERENCE: 5,
    FEEDBACK_FORM: 10    
};